export const services = [
  {
    id: 1,
    name: "Consultoría Digital Estratégica",
    category: "consultoria",
    price: 299,
    originalPrice: 399,
    rating: 4.9,
    duration: 2,
    clients: 150,
    deliveryTime: "3-5 días",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    description: "Análisis completo de tu presencia digital con estrategias personalizadas para maximizar tu impacto online.",
    features: [
      "Análisis SEO completo",
      "Estrategia redes sociales",
      "Reporte competitivo",
      "Plan de acción 90 días",
      "3 sesiones de seguimiento",
      "Auditoría de marca"
    ],
    isPopular: true
  },
  {
    id: 2,
    name: "Desarrollo Web Premium",
    category: "desarrollo",
    price: 1200,
    rating: 4.8,
    duration: 40,
    clients: 89,
    deliveryTime: "2-3 semanas",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    description: "Sitios web responsivos y optimizados con las últimas tecnologías para garantizar máximo rendimiento.",
    features: [
      "Diseño responsive",
      "Optimización SEO",
      "Integración CMS",
      "Certificado SSL",
      "Backup automático",
      "Soporte 24/7"
    ],
    isPopular: false
  },
  {
    id: 3,
    name: "Marketing en Redes Sociales",
    category: "marketing",
    price: 450,
    rating: 4.7,
    duration: 10,
    clients: 234,
    deliveryTime: "1 semana",
    image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    description: "Gestión profesional de tus redes sociales para aumentar engagement y generar leads cualificados.",
    features: [
      "Estrategia de contenido",
      "Calendarización mensual",
      "Community management",
      "Análisis de métricas",
      "Creación de contenido",
      "Reportes semanales"
    ],
    isPopular: true
  },
  {
    id: 4,
    name: "Branding Corporativo",
    category: "diseño",
    price: 750,
    rating: 4.9,
    duration: 15,
    clients: 67,
    deliveryTime: "2 semanas",
    image: "https://images.unsplash.com/photo-1565688534245-05d6b5be184a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    description: "Desarrollo de identidad visual completa que refleje los valores y esencia de tu marca.",
    features: [
      "Diseño de logo",
      "Manual de marca",
      "Paleta de colores",
      "Tipografía corporativa",
      "Diseño de papelería",
      "Guidelines de aplicación"
    ],
    isPopular: false
  },
  {
    id: 5,
    name: "SEO Avanzado",
    category: "seo",
    price: 600,
    rating: 4.8,
    duration: 20,
    clients: 178,
    deliveryTime: "4 semanas",
    image: "https://images.unsplash.com/photo-1607799279861-4dd421887fb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    description: "Optimización técnica y de contenido para posicionar tu sitio web en los primeros resultados de búsqueda.",
    features: [
      "Auditoría técnica SEO",
      "Investigación de keywords",
      "Optimización on-page",
      "Link building",
      "Reporte de posicionamiento",
      "Análisis de competencia"
    ],
    isPopular: true
  },
  {
    id: 6,
    name: "Video Marketing",
    category: "video",
    price: 850,
    rating: 4.7,
    duration: 25,
    clients: 92,
    deliveryTime: "3 semanas",
    image: "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    description: "Producción de contenido audiovisual profesional para conectar con tu audiencia de manera impactante.",
    features: [
      "Guion y storyboard",
      "Grabación profesional",
      "Edición y postproducción",
      "Motion graphics",
      "Optimización para plataformas",
      "Estrategia de distribución"
    ],
    isPopular: false
  }
];